import { Grid } from '@mui/material';
import useAryLayoutType from 'framework/base/hooks/useAryLayoutType';
import React, { useState } from 'react';
import EmptyDropZone from './EmptyDropZone';
import AryUploadedFileItems from './FileItem';
import AryMobileUploadedFileItem from './MobileFileItem';
import { thumbsContainer } from './StyledComponents';
import UploadImageMenu from './UploadImageMenu';

function HasContentDropZone({
  readOnly,
  previews,
  onShowPreview,
  updatePreviewsAfterFileDownloaded,
  files,
  prevFiles,
  propsFileIds,
  handleRemovedFileIds,
  removedFileIds,
  onChange,
  setPreviews,
  setPrevFiles,
  handleSavedFileIds,
  handleSetPreviewData,
  handleOpenWebcam,
  hasWebcam,
  handleSetDisabledDropzone
}) {
  const layoutType = useAryLayoutType();
  const [anchorEl, setAnchorEl] = useState(false);
  const handlePopoverOpen = (event) => {
    if (!hasWebcam) return;
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    if (!hasWebcam) return;
    // event.stopPropagation();
    setAnchorEl(null);
  };
  if (layoutType === 'mobile') {
    return (
      <Grid container>
        <EmptyDropZone />
        <Grid width="100%" display="flex" flexDirection="column" gap={5} mt={1}>
          {previews.map(
            (preview, index) =>
              !removedFileIds.includes(preview.fileId) && (
                <AryMobileUploadedFileItem
                  key={index}
                  preview={preview}
                  index={index}
                  onShowPreview={onShowPreview}
                  previews={previews}
                  updatePreviewsAfterFileDownloaded={
                    updatePreviewsAfterFileDownloaded
                  }
                  readOnly={readOnly}
                  files={files}
                  prevFiles={prevFiles}
                  propsFileIds={propsFileIds}
                  handleRemovedFileIds={handleRemovedFileIds}
                  removedFileIds={removedFileIds}
                  onChange={onChange}
                  setPreviews={setPreviews}
                  setPrevFiles={setPrevFiles}
                  handleSavedFileIds={handleSavedFileIds}
                  handleSetPreviewData={handleSetPreviewData}
                  handleSetDisabledDropzone={handleSetDisabledDropzone}
                />
              )
          )}
        </Grid>
      </Grid>
    );
  }
  return (
    <div
      style={thumbsContainer}
      onMouseEnter={handlePopoverOpen}
      onMouseLeave={handlePopoverClose}
    >
      {previews.map((preview, index) => (
        <AryUploadedFileItems
          key={index}
          preview={preview}
          index={index}
          // setPreviewImagesModalOpen={setPreviewImagesModalOpen}
          onShowPreview={onShowPreview}
          previews={previews}
          updatePreviewsAfterFileDownloaded={updatePreviewsAfterFileDownloaded}
          readOnly={readOnly}
          files={files}
          prevFiles={prevFiles}
          propsFileIds={propsFileIds}
          handleRemovedFileIds={handleRemovedFileIds}
          removedFileIds={removedFileIds}
          onChange={onChange}
          setPreviews={setPreviews}
          setPrevFiles={setPrevFiles}
          handleSavedFileIds={handleSavedFileIds}
          handleSetPreviewData={handleSetPreviewData}
          handleSetDisabledDropzone={handleSetDisabledDropzone}
        />
      ))}
      {anchorEl && !readOnly && (
        <UploadImageMenu handleOpenWebcam={handleOpenWebcam} />
      )}
    </div>
  );
}

export default HasContentDropZone;
